import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function cardDocumentTypesReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state
        .set('loading', false)
        .set('data', mapDocumentTypes(state, action.payload))
        .set('tried', true);
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    default:
      return state;
  }
}

function mapDocumentTypes(state, payload) {
  const documentTypes = Map({ [payload.cardTypeId]: payload.data });
  const data = state.get('data');

  return data ? data.merge(documentTypes) : documentTypes;
}
